
<template>
    <Modal v-model="modal"
           :mask-closable="false"
           :loading="loading"
           :title="$t('卸载文件系统')"
           :ok-text="$t('确定')"
           width="580"
           @on-ok="submit">
        <div class="delete-container">
            <i class="ivu-icon ivu-icon-ios-help-circle"></i>
            <div class="content">
                <p class="desc">{{$t('卸载会强制停止作业进程，请仔细检查当前是否存在运行中作业或其他文件占用使用')}}！</p>
            </div>
        </div>
        <Form ref="form"
              :model="formData"
              :rules="rules"
              :label-width="150">
            <FormItem :label="$t('集群名称')+':'">{{provideData.clusterName}}</FormItem>
            <FormItem :label="$t('文件系统')+':'"
                      prop="share">
                <Select v-model="formData.share"
                        style="width:250px">
                    <Option v-for="item in shareList"
                            :key="item.id"
                            :value="item.id">{{item.name}}</Option>
                </Select>
            </FormItem>
        </Form>
    </Modal>
</template>

<script>
import API from '@/service/api'
export default {
    name: 'storageUninstall',
    data () {
        return {
            modal: false,
            loading: true,
            provideData: {},
            formData: {
                share: ''
            },
            shareList: [],
            rules: {
                share: { required: true, message: '请选择集群', trigger: 'change' }
            }
        }
    },
    methods: {
        changeLoading () {
            this.loading = false
            this.$nextTick(() => {
                this.loading = true
            })
        },
        open (data, param) {
            this.provideData = data
            this.modal = true
            this.axios.get(this.urlFormat(API.SHARE), {
                params: {
                    statusNotIn: 'deleted',
                    hpcClusterId: data.clusterId,
                    ...param
                }
            }).then(res => {
                const shareList = res.filter(item => !['modifying', 'mounting', 'uninstall_stalling'].includes(item.status) && !item.isClusterDefault)
                shareList.forEach(item => { item.id = `${item.id}` })
                this.shareList = shareList
            })
        },
        // 提交
        submit () {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    this.changeLoading()
                    return
                }
                this.$Modal.confirm({
                    title: this.$t(`确认从集群[${this.provideData.clusterName}]卸载当前文件系统 ?`),
                    content: this.$t('卸载会强制停止作业进程，请仔细检查当前是否存在运行中作业或其他文件占用使用！'),
                    onOk: () => {
                        this.axios.delete(this.urlFormat(API.SHARE_UNINSTAILL_SHARE, false, [this.formData.share])).then((res) => {
                            if (res.status === true) {
                                this.$emit('refresh')
                                this.modal = false
                            } else {
                                this.changeLoading()
                            }
                        }).catch(() => {
                            this.changeLoading()
                        })
                    }
                })
            })
        }
    },
    watch: {
        modal (val) {
            if (!val) {
                this.$refs.form.resetFields()
                this.formData = {
                    share: ''
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
.delete-container {
    padding: 0 0 20px 52px;
    i {
        color: #ff9900;
        font-size: 28px;
        float: left;
    }
    h4 {
        font-size: 14px;
        padding: 3px 0 10px 0;
        font-weight: 500;
    }
    .content {
        padding-left: 38px;
    }
    .desc {
        // color: rgb(239, 66, 53);
        font-size: 12px;
        padding-top: 5px;
    }
}
</style>
